import { render, staticRenderFns } from "./TemplateMailliste.vue?vue&type=template&id=7922dcec"
import script from "./TemplateMailliste.vue?vue&type=script&lang=js"
export * from "./TemplateMailliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports